import Controller from "../../../../core/js/Controller";

export default class NewsView extends Controller {
    constructor() {
        super();
    }

    afterInit() {

    }

    copyLink(e, el) {
        e.preventDefault();

        this.copyToClipboard(el.dataset.link);

        this.shareModal.style.display = 'flex';
        setTimeout(() => {
            this.shareModal.addClass('open');
            setTimeout(() => {
                this.shareModal.removeClass('open');

                setTimeout(() => {
                    this.shareModal.style.display = 'none';
                }, 500);
            }, 1500);
        }, 10);
    }

    copyToClipboard(str) {
        var el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
    };
}